module.exports = __webpack_public_path__ + "img/sfty2.bcd5dcdd.jpg";